<template>
  <div class="middle-box text-center loginscreen animated fadeInDown">
    <div>
      <div>
        <h1>
          <center>
            <img
              :src="require('@/assets/image/main-logo.png')"
              width="70%"
              alt="Logo Robo Market"
            />
          </center>
        </h1>
      </div>
      <h3>Login</h3>

      <form class="m-t" role="form" @submit.prevent="doLogin()">
        <div class="form-group">
          <input
            v-model="user.email"
            type="email"
            :disabled="isLoading"
            class="form-control"
            placeholder="E-mail"
            required
          />
        </div>
        <div class="form-group">
          <input
            v-model="user.password"
            type="password"
            :disabled="isLoading"
            class="form-control"
            placeholder="Senha"
            required
          />
        </div>
        <button
          :disabled="isLoading"
          type="submit"
          class="btn btn-primary block full-width m-b"
        >
          {{ isLoading ? "Processando..." : "Entrar" }}
        </button>

        <router-link to="/recuperar-senha">
          <small>Esqueceu a senha?</small>
        </router-link>

        |

        <router-link to="/">
          <small>Ir para a Home</small>
        </router-link>
      </form>
      <p class="m-t">
        <small>RoboMarket &copy; {{ curYear }}</small>
      </p>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import * as firebase from "firebase/app";
import "firebase/auth";

export default {
  computed: {
    curYear: function () {
      return new Date().getFullYear();
    },
  },

  methods: {
    async doLogin() {
      this.$data.isLoading = true;
      const user = this.$data.user;
      try {
        await firebase.auth()
          .signInWithEmailAndPassword(user.email, user.password);
	      this.$router.replace('/dashboard');
      } catch (error) {
        alert('Erro ao logar. Certifique-se de que preencheu corretamente as informações.');
        this.$data.isLoading = false;
      }
    },
  },

  data() {
    return {
      isLoading: false,
      refreshed: false,
      user: {
        email: "",
        password: "",
      },
    };
  },
  beforeCreate() {
    if (!document.body.classList.contains("gray-bg"))
      document.body.classList.add("gray-bg");
  },

  mounted() {
    if(!this.$data.refreshed) this.$forceUpdate();
    this.$data.refreshed = true;
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/admin/css/bootstrap.min.css";
@import "../../assets/admin/font-awesome/css/font-awesome.css";
@import "../../assets/admin/css/animate.css";
@import "../../assets/admin/css/style.css";
</style>
